export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10624.53c58e57.jpg";